// extracted by mini-css-extract-plugin
export var errorIcon = "_nw-1";
export var nameLogo = "_nw-0";